// IE 2026 10 23 / ODOO-348692 (заказ Игоря: поиск чипса по заголовкам колонок): чистая логика поиска чипса по ЗАГОЛОВКАМ КОЛОНОК таблицы (без Vue и DOM) —
// сбор текстов ячеек шапки wijmo (все ряды панели columnHeaders; объединённые диапазоны — группы колонок — один раз; скрытые ряды, колонки и подписи — мимо),
// части запроса, найденные в шапке, фраза в шапке, остановки ‹ ›. Хост — AttrGrid (gridSearch_headerCells / gridSearch_headHit / gridSearchNav_recompute).
// Юнит: handoff-files/grid-search-headers-2026-10-23/gridSearchHeaders.test.mjs
import { fuzzyFindTier, phraseFind } from './searchMatch'

// ячейки шапки: [{ hr, c, text (нижний регистр), raw }]. flex — FlexGrid (или утиная копия: columns[], columnHeaders.rows[], columnHeaders.getCellData, getMergedRange).
// o.columnNumberRow — ряд номеров колонок (текст — номер, как рисует formatItem); o.stickyScrollStart — с этого ряда служебные sticky-ряды (титул живёт в оверлее);
// o.blankLevels(binding) → Set рядов, чья подпись погашена свёрткой дат (foldHdr_blankCell); o.hiddenTitle(binding, raw) → подпись меры скрыта (hideTitle)
export function headerCells_collect(flex, o = {}) {
    const out = []
    const panel = flex && flex.columnHeaders, hrows = panel && panel.rows, cols = flex && flex.columns
    if (!hrows || !cols) return out
    const nR = hrows.length, nC = cols.length
    for (let hr = 0; hr < nR; hr++) {
        const row = hrows[hr]
        if (!row || row.visible === false) continue
        if (o.stickyScrollStart != null && hr >= o.stickyScrollStart) continue
        for (let c = 0; c < nC; c++) {
            const col = cols[c]
            if (!col || col.isVisible === false) continue
            let rng = null
            try { rng = flex.getMergedRange(panel, hr, c, false) } catch (e) { rng = null }
            if (rng && (rng.topRow !== hr || rng.leftCol !== c)) continue   // объединение (группа колонок «2025») — один раз, по левой верхней ячейке
            let raw = ''
            if (hr === o.columnNumberRow) raw = String(c + 1)
            else { try { raw = String(panel.getCellData(hr, c, true) ?? '') } catch (e) { raw = '' } }
            raw = raw.trim()
            if (!raw) continue
            if (o.blankLevels) { const lv = o.blankLevels(col.binding); if (lv && lv.has(hr)) continue }
            if (o.hiddenTitle && hr !== o.columnNumberRow && o.hiddenTitle(col.binding, raw)) continue
            out.push({ hr, c, text: raw.toLowerCase(), raw })
        }
    }
    return out
}
// части запроса (строки, как в apply_CHIPS / gridSearch_hasTerms), найденные хоть в одном заголовке, — Set; tier — ступень опечаток (0 — точно)
export function headerHit_terms(cells, terms, tier = 0) {
    const out = new Set()
    if (!cells || !cells.length || !terms || !terms.length) return out
    for (const t of terms) {
        const tl = String(t ?? '').toLowerCase()
        if (!tl) continue
        if (cells.some(h => tier ? !!fuzzyFindTier(h.text, tl, tier) : h.text.includes(tl))) out.add(t)
    }
    return out
}
// фраза (utils/searchMatch.searchPhrase) есть хоть в одном заголовке
export function headerHit_phrase(cells, phrase) {
    return !!phrase && !!cells && cells.some(h => !!phraseFind(h.text, phrase))
}
// IE 2026 10 24 / ODOO-348692 (заказ Игоря: подсветка шапки не снималась после снятия чипса поиска): подпись активных чипсов поиска — по ней грид понимает, что подсветку шапки надо перерисовать (добавлен / снят чипс, сменился текст, режим опечаток, use)
export function headerSearch_sig(chips, on = true) {
    if (!on || !chips || !chips.length) return ''
    const out = []
    for (const c of chips) {
        if (!c || c.segment !== 'CHIP-Search' || (c.meta && c.meta.use === false)) continue
        out.push([c.title == null ? '' : c.title, c._fuzzy || 0, c._phrase && c._phrase.text ? c._phrase.text : '', c._layoutConvFrom || '', c._alt ? 1 : 0].join('\u241F'))
    }
    return out.join('\u241E')
}
// части без найденных в шапке (отбор строк apply_CHIPS: AND по строке только по остальным; пусто — строки не прячутся)
export function headerExclude_terms(terms, hit) { return (terms || []).filter(t => !hit || !hit.has(t)) }
// остановки ‹ › в шапке: terms — как в gridSearchNav_recompute ([{ t, phrase, tier }]); порядок — ряд за рядом сверху вниз, в ряду слева направо; не больше max
export function headerNav_stops(cells, terms, max = Infinity) {
    const out = []
    if (!cells || !terms || !terms.length) return out
    for (const h of cells) {
        const hit = terms.some(t => t.phrase ? !!phraseFind(h.text, t.phrase) : (t.tier ? !!fuzzyFindTier(h.text, t.t, t.tier) : h.text.includes(t.t)))
        if (hit) { out.push({ r: h.hr, c: h.c, head: true }); if (out.length >= max) break }
    }
    return out
}
